import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { OrderWindow } from '../../../models/order-window.model';
import {MultiTenantService} from '../../../services/multi-tenant.service';
import {isEmptyArray} from '../../../shared/utils';
import { DATE_FORMAT } from 'app/constants/date-format';

@Component({
    selector: 'app-select-order-window',
    templateUrl: './select-order-window.component.html',
    styleUrls: ['./select-order-window.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SelectOrderWindowComponent {
    protected readonly OrderWindow = OrderWindow;
    public defaultLongDateFormat = DATE_FORMAT.LONG_FORMAT;
    @Input() mobile = false;

    @Input() orderWindows: OrderWindow[] = [];

    @Input() selectedOrderWindowId: number;

    @Input() hideTitle = false;

    @Output() changedOrderWindow = new EventEmitter<OrderWindow>();

    constructor(
      private multiTenantService: MultiTenantService
    ) {}


    onChangeOrderWindow($event: {} | Event) {
        if ($event instanceof  OrderWindow) {
            this.changedOrderWindow.emit($event);
        }
    }

    formattedLabel(item: OrderWindow): string {
        if (!item.id) {
            return '';
        }
        const state = (item.active) ? '<span class="text-green ml-2">Open</span>' : '<span class="text-red ml-2">Closed</span>';
        return `<strong>${item.label}</strong>  (${this.formattedDates(item)}) ${state}`;
    }

    formattedDates(item: OrderWindow) {
        if (!item.start_at || !item.end_at) {
            return;
        }
        return `${item.start_at.format(this.defaultLongDateFormat)} - ${item.end_at.format(this.defaultLongDateFormat)}`;
    }


    get orderWindowLabel(): string {
        return this.multiTenantService.orderWindowLabel
    }

    get hasOrderWindows(): boolean {
        return !isEmptyArray(this.orderWindows);
    }
}
